import comp from "./ResourceCardV1";
export default comp;
